<template>
  <div>
    <b-button v-if="value == true" variant="checkbox">
      <img
        :src="asset('images/checkbox-arrow-gray.png')"
        alt="person"
        width="15"
        height="9"
      />
    </b-button>
    <b-button v-else-if="value == false" variant="checkbox--active">
      <img
        :src="asset('images/checkbox-arrow-green.png')"
        alt="person"
        width="15"
        height="9"
      />
    </b-button>
    <b-button v-else-if="value == null" variant="checkbox" disabled>
      <img
        :src="asset('images/checkbox-arrow-gray.png')"
        alt="person"
        width="15"
        height="9"
      />
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'CheckboxButton',
  props: {
    value: {
      type: [Boolean],
      default: null,
    },
  },
};
</script>
